import { DispatchConstants } from './constants';
import type { SplitExperimentProps } from './types';

export const SplitActions = {
  updateSplitExperiments: (payload: SplitExperimentProps) => ({
    type: DispatchConstants.UPDATE_SPLIT_EXPERIMENTS,
    payload,
  }),
  /**
   * @param {string} payload - name of the treatment
   */
  deleteSplitExperiment: (payload: string) => ({
    type: DispatchConstants.DELETE_SPLIT_EXPERIMENT,
    payload,
  }),
  updateSplitFeatureNames: (payload: Array<string>) => ({
    type: DispatchConstants.UPDATE_SPLIT_FEATURE_NAMES,
    payload,
  }),
};
